export default {
    data() {
        return {
            'recaptcha_token': '',
        }
    },

    mounted() {
        this.initRecaptcha()
    },

    methods: {
        async initRecaptcha() {
            await this.$recaptchaLoaded()

            const token = await this.$recaptcha('redeem')

            if (token) {
                this.recaptcha_token = token;

                return
            }

            this.recaptcha_token = null;
        }
    }
}
